var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lead-status",class:_vm.colorClass},[_vm._t("default"),(_vm.statusKey)?[_vm._v(" "+_vm._s(_vm.$t(("leadStatus." + _vm.statusKey + ".label")))+" ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }